import React from "react";
import TopBar from "@/components/TopBar";
import Footer from "@/components/Footer";

export default function Disclaimer() {
  return (
    <div className="min-h-screen bg-[#050505] text-white flex flex-col">
      <TopBar />
      <div className="flex-1 max-w-3xl mx-auto px-6 py-10 text-sm leading-relaxed text-[#c0c0c0]">
        <div className="micro-label">/ legal</div>
        <h1 className="font-heading text-3xl mt-1 mb-8">Disclaimer</h1>

        <section className="space-y-4">
          <h2 className="font-heading text-lg text-white mt-6">Not investment advice</h2>
          <p>
            All content, tools, data, charts, backtest results, AI-generated insights, AI-generated
            options strategies, momentum scores, signals, watchlists, and any other output produced
            by <strong>Momentum Terminal</strong> at <em>tracker.piratetrader.com</em>
            (collectively, the “Service”) are provided <strong>strictly for informational and
            educational purposes only</strong>. Nothing in the Service constitutes investment advice,
            financial advice, trading advice, or a recommendation to buy, sell, or hold any security,
            option, or other financial instrument.
          </p>

          <h2 className="font-heading text-lg text-white mt-6">Not a registered adviser</h2>
          <p>
            The operators of this Service are <strong>not licensed investment advisers</strong>,
            broker-dealers, or financial planners. No fiduciary relationship is created by your use
            of the Service. Consult a qualified, licensed professional before making any investment
            decision.
          </p>

          <h2 className="font-heading text-lg text-white mt-6">Options trading risk</h2>
          <p>
            Options trading involves substantial risk of loss and is not suitable for all investors.
            You may lose your entire investment rapidly. Prior to trading options you should read the
            Options Clearing Corporation's disclosure document{" "}
            <a href="https://www.theocc.com/company-information/documents-and-archives/options-disclosure-document"
               target="_blank" rel="noopener noreferrer"
               className="underline hover:text-white">
              “Characteristics and Risks of Standardized Options.”
            </a>
          </p>

          <h2 className="font-heading text-lg text-white mt-6">Data & accuracy</h2>
          <p>
            Market data is provided by third-party providers (including Twelve Data and Yahoo Finance)
            and may be delayed, inaccurate, or incomplete. We make no representations or warranties as
            to accuracy, timeliness, or completeness. Do not rely on the Service as your sole source
            of information for any trading decision.
          </p>

          <h2 className="font-heading text-lg text-white mt-6">AI-generated content</h2>
          <p>
            Insights, narratives, and strategies generated by artificial intelligence (Claude Sonnet
            4.5) are produced by machine learning models and may be inaccurate, incomplete, or
            hallucinated. AI output does not reflect the opinions of the operators and must not be
            treated as a professional recommendation.
          </p>

          <h2 className="font-heading text-lg text-white mt-6">Backtest results</h2>
          <p>
            Backtest results are based on historical market data and hypothetical trade execution.
            They do not include commissions, slippage, taxes, or execution risk. <strong>Past
            performance is not indicative of future results.</strong> Hypothetical performance has
            many inherent limitations, some of which are described below. No representation is being
            made that any account will or is likely to achieve profits or losses similar to those
            shown.
          </p>

          <h2 className="font-heading text-lg text-white mt-6">Limitation of liability</h2>
          <p>
            To the maximum extent permitted by law, in no event will the operators of this Service
            be liable for any direct, indirect, incidental, special, consequential, or punitive
            damages, including without limitation loss of profits, data, or use, arising out of or
            in any way connected with your use of, or inability to use, the Service.
          </p>

          <h2 className="font-heading text-lg text-white mt-6">Your acknowledgement</h2>
          <p>
            By using this Service, you acknowledge that you have read this disclaimer, that you
            understand it, and that you agree to be bound by its terms. If you do not agree, do not
            use the Service.
          </p>

          <p className="text-xs text-[#555] mt-8">Last updated: {new Date().toISOString().slice(0,10)}</p>
        </section>
      </div>
      <Footer />
    </div>
  );
}
